exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* html,\nbody,\n#app {\n  margin: 0;\n  height: 100%;\n} */\n#app {\n  font-family: \"PingFangSC\", \"PingFangSC-Medium\", \"Arial\", \"Helvetica\", sans-serif, \"SimHei\", \"Microsoft YaHei\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n}\nul,\nli,\na,\nh1,\nh2,\nh3 {\n  margin: 0;\n  padding: 0;\n}\ndiv {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\nli {\n  list-style: none;\n}\na {\n  text-decoration: none;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05e82cb6","scoped":false,"hasInlineConfig":false}!./~/px2rem-loader?{"remUnit":198,"baseDpr":1}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 1012
// module chunks = 7